import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const heroSection = document.querySelectorAll('.past-events-section');

    heroSection.forEach(section => {
        const hhSlider = section.querySelectorAll('.pes-slider');

        hhSlider.forEach(slider => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: section.querySelector('.pes-button-next'),
                    prevEl: section.querySelector('.pes-button-prev'),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    });
});